import { Menu } from "lucide-react";
import { Button } from "src/components/ui/button";

interface NavigationEmptyStateProps {
	onCreate: () => void;
}

const NavigationEmptyState = ({ onCreate }: NavigationEmptyStateProps) => {
	return (
		<div className="flex flex-col items-center justify-center py-20 text-center">
			<div className="w-16 h-16 rounded-full bg-zinc-100 flex items-center justify-center mb-4">
				<Menu className="h-8 w-8 text-zinc-500" />
			</div>
			<label className="font-heading text-lg font-medium text-foreground mb-2 block">
				No menu items yet
			</label>
			<p className="text-sm text-muted-foreground mb-6 max-w-sm">
				Create your first menu item to start building the mobile app navigation.
			</p>
			<Button onClick={onCreate}>Create your first menu item</Button>
		</div>
	);
};

export default NavigationEmptyState;
